interface BasePaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  total?: number;
  limit?: number;
}

export const BasePagination = ({page, totalPages, onPageChange, total, limit}: BasePaginationProps) => {
  if (totalPages <= 1) return null;

  const from = total && limit ? (page - 1) * limit + 1 : undefined;
  const to = total && limit ? Math.min(page * limit, total) : undefined;

  const pages = Array.from({length: Math.min(totalPages, 5)}, (_, i) => {
    if (totalPages <= 5) return i + 1;
    if (page <= 3) return i + 1;
    if (page >= totalPages - 2) return totalPages - 4 + i;
    return page - 2 + i;
  });

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-(--color-border)">
      {total && limit ? (
        <p className="text-sm text-(--color-text-secondary)">
          Showing <span className="font-medium">{from}</span> to <span className="font-medium">{to}</span> of{" "}
          <span className="font-medium">{total}</span> results
        </p>
      ) : (
        <span />
      )}

      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="px-2 py-1 text-sm rounded-sm border border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-surface-2) disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          ←
        </button>

        {pages.map(p => (
          <button
            type="button"
            key={p}
            onClick={() => onPageChange(p)}
            className={[
              "w-8 h-8 text-sm rounded-sm border transition-colors",
              p === page
                ? "bg-(--color-primary) text-white border-(--color-primary)"
                : "border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-surface-2)",
            ].join(" ")}
          >
            {p}
          </button>
        ))}

        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="px-2 py-1 text-sm rounded-sm border border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-surface-2) disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          →
        </button>
      </div>
    </div>
  );
};
